import { useCallback } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

type Props = {
  isEdit?: boolean;
  defaultValuesItems?: any;
};

export const useItemList = ({ defaultValuesItems, isEdit }: Props) => {
  const { control, setValue, watch } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'items',
  });
  const handleAdd = () => {
    append({
      product: '',
      quantity: 1,
    });
  };

  const handleChangeQuantity = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index: number) => {
      const quantity = Number(event.target.value);

      const orderDetailEdit = fields[index] as any;
      if (isEdit) {
        const temporalQuantity = defaultValuesItems.find(
          (item: any) => item.product.value === orderDetailEdit.product.value
        ).quantity;
        if (quantity <= temporalQuantity) {
          setValue(`items[${index}].quantity`, quantity);
        }
      } else {
        setValue(`items[${index}].quantity`, quantity);
      }
    },
    [defaultValuesItems, fields, isEdit, setValue]
  );

  const handleRemove = (index: number) => {
    remove(index);
  };

  return {
    fields,
    setValue,
    handleAdd,
    handleChangeQuantity,
    handleRemove,
    items: watch(),
    append,
    remove,
  };
};
